<div class="flexie-auto-grid m-t-b-60">

  <div class="v-a-top">
    <div *ngIf="!savedAdd">
      <div class="zero-ui">
        <i nz-icon nzType="schedule" nzTheme="outline"></i>
        <h2>Add Address</h2>
        <p>You need to at-least one address to continue</p>
      </div>
    </div>
    <div *ngIf="!!savedAdd">
      <h3> Addresses </h3>
      <nz-list
              [nzDataSource]="list"
              [nzItemLayout]="'horizontal'"
              [nzRenderItem]="item">
        <ng-template #item let-item>
          <nz-list-item [nzActions]="[editAction]">
            <nz-skeleton [nzActive]="true" [nzLoading]="false">
              <ng-template #editAction><a>edit</a></ng-template>
              <nz-list-item-meta
                      [nzTitle]="'Home Address'"
                      [nzDescription]="'A 40'+(item+1)+', Palacio, Water Edge Society, Central Perk'">
              </nz-list-item-meta>
            </nz-skeleton>
          </nz-list-item>
        </ng-template>
      </nz-list>
    </div>
  </div>

  <div>
    <div class="form-secondary">

      <h3 class="form-secondary-heading">+ Add Address</h3>

      <div class="form-secondary-fields p-l-r-20 p-t-b-10">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Address Line 1, 2, 3</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Address Line 1" name="input-basic"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Address Line 2" name="input-basic"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Address Line 3" name="input-basic"/>
          </nz-form-control>
        </nz-form-item>
        <!-- 3 -->
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">PIN Code</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-input placeholder="PIN" name="input-basic" style="width: 100%"/>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Country</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  [ngModel]="'India'" style="width: 100%">
                  <nz-option [nzLabel]="'India'" [nzValue]="'India'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="flexie-auto-grid">
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">State</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  [ngModel]="'Maharashtra'" style="width: 100%">
                  <nz-option [nzLabel]="'Maharashtra'" [nzValue]="'Maharashtra'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label [nzSpan]="24">City</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  [ngModel]="'Mumbai'" style="width: 100%">
                  <nz-option [nzLabel]="'Mumbai'" [nzValue]="'Mumbai'"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
      

      <div class="footer-actions-bar">
        <div><!-- Left --></div>
        <div>
          <!-- Right -->
          <button nz-button class="b-0 m-r-10">Clear</button>
          <button nz-button [nzType]="'primary'" (click)="savedAdd=!savedAdd">Add</button>
        </div>
      </div>
    </div>
  </div>

</div>
